const actions = {
  GET_USER: 'USER/GET_USER',
  GET_USER_SUCCESS: 'USER/GET_USER_SUCCESS',
  GET_USER_ERROR: 'USER/GET_USER_ERROR',
  getUser: (userId) => ({
    type: actions.GET_USER,
    userId,
  }),
  getUserSuccess: (user) => ({
    type: actions.GET_USER_SUCCESS,
    user,
  }),
  getUserError: (error) => ({
    type: actions.GET_USER_ERROR,
    error,
  }),
};

export default actions;
